import { render, staticRenderFns } from "./ClearIconButton.vue?vue&type=template&id=1cb394e7&lang=pug&"
import script from "./ClearIconButton.vue?vue&type=script&lang=js&"
export * from "./ClearIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClearIconButton.vue"
export default component.exports